







































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import { Watch } from 'vue-property-decorator';
import { convertCharacters } from '@/helpers/convertCharacters';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { dateFormat } from '../../../helpers/dateFormat';
import { FiltroModeloParmDTO, ModeloListItemDTO } from '@/interfaces/bag-models';
import { PaginationSyncDTO, ResultPagDTO } from '../../../interfaces/base-dto';
import BagModelForm from '../../../components/bag-models/bag-model-form.vue';
import * as service from '../../../services/bag-models';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    BagModelForm,
  },
})
export default class BagModel extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filtros = new FiltroModeloParmDTO();
  public id: Number = null;

  public headers: any = [
    { text: 'Código', value: 'codigo', sortable: false, },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Capacidade', value: 'capacidadeMlFormat', sortable: false, align: 'center', },
    { text: 'Compartimentos', value: 'compartimento', sortable: false, align: 'center', },
    { text: 'Usuário alteração', value: 'alteradoPor', sortable: false, align: 'center', },
    { text: 'Data', value: 'ultimaAlteracao', sortable: false, align: 'center', },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<ModeloListItemDTO> = new ResultPagDTO<ModeloListItemDTO>();
  public items: ModeloListItemDTO[] = [];

  private mounted(): void {
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.pesquisar();
  }

  pesquisar() {
    this.items = [];
    this.loading = true;
    this.error = false;
    this.filtros.page = this.pagination.page;
    this.filtros.size = this.pagination.rowsPerPage;
    this.addSubsc(
      service.findBagModels(this.filtros).subscribe(
        (result) => {
          this.items = result.content;
          PaginationSyncDTO.update(this.pagination, result);
          this.loading = false;
          this.error = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
